import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { UsuarioAutorizadoModel } from '../models/usuario-autorizado.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UsuarioAutorizadoVehiculoModel } from '../models/usuario-autorizado-vehiculo.model';
import { Observable } from 'rxjs';
import { VehiculoModel } from '../models/vehiculo.model';

@Injectable({
  providedIn: 'root'
})
export class UsuarioAutorizadoService extends BaseService<UsuarioAutorizadoModel> {

  tipo: string;
  urlBase: string;
  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.tipo = 'Usuario autorizado';
    this.urlBase = `${environment.baseApi}${environment.endPoints.usuarioAutorizado.base_usuarioAutorizado}`;

  }


  autorizarPersona(dniVehiculo: UsuarioAutorizadoVehiculoModel): Observable<UsuarioAutorizadoVehiculoModel> {
    return this.httpClient.post<UsuarioAutorizadoVehiculoModel>(`${this.urlBase}`, dniVehiculo);
  }

  autorizarPersonaVehiculo(nif: string, vehiculo: VehiculoModel): Observable<UsuarioAutorizadoVehiculoModel> {
    const formData = new FormData();
    formData.append('nif', nif );
    formData.append('idVehiculo', vehiculo.id.toString());
    return this.httpClient.post<UsuarioAutorizadoVehiculoModel>(`${this.urlBase}/usuario`, formData);

  }

  eliminarAutorizado(dniVehiculo: UsuarioAutorizadoVehiculoModel): Observable<any> {
    return this.httpClient.post<any>(`${this.urlBase}/delete`, dniVehiculo);
  }

  findVehiculoByIdAutorizacion() { }

  findAutorizadosByIdVehiculos(id: number): Observable<string[]> {
    return this.httpClient.get<string[]>(`${this.urlBase}${environment.endPoints.usuarioAutorizado.me}${environment.endPoints.usuarioAutorizado.autorizadosVehiculos}/${id}${environment.endPoints.usuarioAutorizado.autorizadoVehiculosAut}`);
  }

  findAutorizadosByMiVehiculo() { }

  findVehiculosAutorizadosForMe() { }
}
